const themeColorsDesingSystem = {
  background: {
    main: "#FFFFFF",
    dark: "#424242",
  },
  primary: {
    main: "#13294B",
    active: "#091629",
    dark: "#0b192d",
  },
  secondary: {
    main: "#A4B4E8",
    active: "#BFCBF0",
  },
  text: {
    primary: "#424242",
    secondary: "#FFFFFF",
  },
  gray: {
    main: "#A0A4B3",
    dark: "#646981",
  },
  stone: {
    light: "#F1F1F4",
    main: "#E6E6E6",
    medium: "#C2C2C2",
    dark: "#828282",
  },
  green: {
    main: "#0AA836",
    background: "#0AA83612",
    backgroundActive: "#0AA83633",
  },
  orange: {
    background: "#febeb1",
    light: "#fb6340",
    main: "#ff3709",
  },
  yellow: {
    main: "#ffd600",
    background: "#ffe06633",
  },
  red: {
    main: "#EC4A54",
    background: "#A80A0A14",
  },
  transparent: {
    main: "transparent",
    dark: "rgba(0, 0, 0, 0.2)",
  },
  white: {
    main: "#FFFFFF",
  },
  brands: {
    karsten: {
      primary: "#005870",
      secondary: "#92CFCA",
      text: "#374151",
      bgHeader: "#FFFFFF",
      accent: "#005870",
      turquesa: "#92CFCA",
      grafite: "#3C3C3B",
      areia: "#D4D3D3",
      cinza: "#878787",
      bg: "#F4F4F4",
      surface: "#FFFFFF",
      primaryHover: "#004a5e",
    },
    trussardi: {
      primary: "#B7A99A",
      secondary: "#A98B6C",
      text: "#1F2937",
      bgHeader: "#FFFFFF",
      accent: "#B7A99A",
      primaryHover: "#A98B6C",
      bg: "#FFFFFF",
      surface: "#FFFFFF",
      textBase: "#000000",
      textMuted: "#6B6B6B",
      border: "#EAEAEA",
    },
  },
};

export default themeColorsDesingSystem;
